<figure class="ContTodos">
  <div class="contIconG">
      <a  class="buttonIconG">
        <img class="IconEditG" *ngIf="imagChoice !== undefined" src="{{imagChoice}}" alt="Icone escolhido">
      </a>

  </div>
  <div >
      <button type="button" *ngFor="let item of imagemButton" (click)="click($event, item.idIcon, item.image)" class="buttonIcon"><img class="iconButtonEdit" src="{{item.image}}" alt=""></button>
  </div>
</figure>